import React from 'react'
import { usePipeline } from '@morningtrain/react-helpers'
import useOnOperationExecute from '../hooks/use-on-operation-execute'

function TriggerPipelineOnOperationExecute () {
  const pipeline = usePipeline()

  useOnOperationExecute((data) => {
    const payload = { data }

    pipeline.trigger(payload)
      .catch((err) => console.log('caught error', err))
  })

  return null
}

export default TriggerPipelineOnOperationExecute
